// removed by extract-text-webpack-plugin
module.exports = {"notValid":"themes_notValid---sbox","border-box":"themes_border-box---sbox","borderBox":"themes_border-box---sbox","text-ellipsis":"themes_text-ellipsis---sbox","textEllipsis":"themes_text-ellipsis---sbox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/themes/default.less
// module id = 544
// module chunks = 0